var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center cursor-pointer",staticStyle:{"height":"100%"},on:{"click":_vm.handleClick}},[_c('vs-chip',{staticStyle:{"font-size":"12px"},attrs:{"color":_vm.getGradColor(101 - _vm.note * 10)}},[_vm._v("\n\t\t  "+_vm._s(_vm.note)+"  \n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }